var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPositive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#266ed1;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun_Smiley_596935",
    "data-name": "noun Smiley 596935"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_856",
    "data-name": "Path 856",
    className: "cls-1",
    d: "M20,0A20,20,0,1,0,40,20,20,20,0,0,0,20,0Zm0,38.33A18.33,18.33,0,1,1,38.33,20h0A18.32,18.32,0,0,1,20,38.33Zm9-11.4a.85.85,0,0,1-.11,1.18h0a13.85,13.85,0,0,1-8.95,3.64A13.3,13.3,0,0,1,11.06,28a.83.83,0,0,1,1.21-1.15c.28.29,7,7.1,15.52-.06a.84.84,0,0,1,1.18.09ZM11.67,15a2.5,2.5,0,1,1,2.5,2.5A2.5,2.5,0,0,1,11.67,15Zm11.66,0a2.5,2.5,0,1,1,2.5,2.5,2.5,2.5,0,0,1-2.5-2.5Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPositive);
export default __webpack_public_path__ + "static/media/positive.36f5fcd9f6bbccf18abdbb654956eb54.svg";
export { ForwardRef as ReactComponent };